import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";

@Injectable()
export class RmsResponseDomainErrorsInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // let pathname=new URL(req.url).pathname;
    // this is the same as above line, but for compatibility in IE 11
    const pathArr = req.url.split("/");
    for (let i = 0; i < 3; i++) {
      pathArr.shift();
    }

    if (pathArr.find(i => i === "jpats")) {
      return next.handle(req).pipe();
    }

    const clone = req.clone();
    return next.handle(clone).pipe(tap((res: any) => {
        if (res instanceof HttpResponse) {
          if (res.headers) {
            if (res.headers.get("X-Domain-Errors")) {
              res.body["DomainExecutionErrors"] = res.headers.get("X-Domain-Errors");
            }
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      }));

  }

}
